export default __webpack_public_path__ + "static/media/right-approve.48b952c3.svg";